import { render, staticRenderFns } from "./SparePartDetailDialog.vue?vue&type=template&id=5187a7be&scoped=true"
import script from "./SparePartDetailDialog.vue?vue&type=script&lang=ts"
export * from "./SparePartDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./SparePartDetailDialog.vue?vue&type=style&index=0&id=5187a7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187a7be",
  null
  
)

export default component.exports